<template>
  <div>
    <div>
      <form-item prop="trigger">
        <radio-group v-model="model.trigger" inline>
          <radio
            :border="true"
            :label="2"
            :title="$t('CampaignForm_Schedule_Standard_Title')"
            :description="$t('CampaignForm_Schedule_Standard_Desc')"
            data-qa="standard-schedule-option-radio"
          />
          <radio
            :border="true"
            :label="4"
            :title="$t('CampaignForm_Schedule_Optimove_Title')"
            :description="$t('CampaignForm_Schedule_Optimove_Desc')"
            data-qa="optimove-schedule-option-radio"
          />
        </radio-group>
      </form-item>
    </div>
    <div class="separator"></div>
    <schedule-selector-triggered
      v-if="model.trigger === campaignTriggerTypes.TRIGGER_EVENT"
      :model="model"
    />
    <schedule-selector-optimove
      v-else-if="model.trigger === campaignTriggerTypes.TRIGGER_OPTIMOVE"
      :model="model"
    />
  </div>
</template>

<script>
import FormItem from '@/common/components/form/FormItem'
import Radio from '@/common/components/form/Radio'
import RadioGroup from '@/common/components/form/RadioGroup'
import ScheduleSelectorOptimove from '@/modules/campaign-manage/components/schedule/ScheduleSelectorOptimove'
import ScheduleSelectorTriggered from '@/modules/campaign-manage/components/schedule/ScheduleSelectorTriggered'
import { campaignTriggerTypes } from '@/modules/campaign-manage/enum/CampaignTriggerTypesEnum'
import { mapGetters } from 'vuex'
export default {
  name: 'ScheduleSelectorOptimoveEvent',
  components: {
    FormItem,
    Radio,
    RadioGroup,
    ScheduleSelectorOptimove,
    ScheduleSelectorTriggered
  },
  data() {
    return {
      campaignTriggerTypes
    }
  },
  props: {
    model: {
      type: Object
    }
  },
  computed: {
    ...mapGetters(['timezones'])
  }
}
</script>

<style scoped>
>>> .el-radio {
  height: unset !important;
  min-height: 80px !important;
  max-height: 120px !important;
  white-space: unset;
}
.separator {
  margin: 24px -20px;
  border-top: 1px solid #ebeef5;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/schedule/ScheduleSelectorOptimoveEvent.vue